<div class="progress-bar-container">
  <prism-ui-heading
    class="progressBarHeaderTitle"
    key-id="heading-default"
    level="1"
    font-size="lg"
    line-height="medium"
    font-weight="regular"
    is-uppercase="false"
    variant="default"
    >
    {{ progressBarHeaderTitle }}
  </prism-ui-heading>
  <prism-ui-progress-bar
    class="medical-history-progress-bar"
    key-id="medical-history-progress-bar"
    [tabsCount]="progressBarSteps.length"
    >
    @for (step of progressBarSteps; track step; let i = $index) {
      <prism-ui-progress-bar-tab
        [state]="getProgressBarState(i)"
        (click)="onStepClick(i)"
        [position]="
          i === 0
            ? 'left'
            : i === progressBarSteps.length - 1
            ? 'right'
            : 'center'
        "
        [keyId]="step.keyid"
        [slot]="i + 1"
        >
        <span [innerHTML]="step.title"></span>
      </prism-ui-progress-bar-tab>
    }
  </prism-ui-progress-bar>
</div>
